export default "__VITE_ASSET__h7vv0rAY__"